declare global {
  interface Window {
    OneTrust?: OneTrust
  }
}
export interface OneTrust {
  ToggleInfoDisplay(): void
  RejectAll(): void
  AllowAll(): void
  UpdateConsent(groupIdType: string, bitValue: string): void
  updateConsentFromCookies(encodedIabString: string): Promise<void>
  SetAlertBoxClosed(): void
  showVendorsList(): void
}

export class OneTrustApiWrapper {
  private oneTrustPromiseInternal: Promise<OneTrust> | undefined

  constructor(
    private readonly ONETRUST_LOAD_TIMEOUT: number,
    private readonly CHECK_INTERVAL: number = 50
  ) {}

  getOneTrustPromise(): Promise<OneTrust> {
    if (this.oneTrustPromiseInternal) {
      return this.oneTrustPromiseInternal
    } else {
      this.oneTrustPromiseInternal = this.init()
    }
    return this.oneTrustPromiseInternal
  }

  private async init(): Promise<OneTrust> {
    try {
      return await new Promise<OneTrust>((resolve, reject) => {
        if (this.isOneTrustInitialized(window.OneTrust)) {
          return resolve(window.OneTrust)
        }

        const startTime = Date.now()

        const checkExistence = setInterval(() => {
          if (this.isOneTrustInitialized(window.OneTrust)) {
            clearInterval(checkExistence)
            return resolve(window.OneTrust)
          }
          if (Date.now() - startTime > this.ONETRUST_LOAD_TIMEOUT) {
            clearInterval(checkExistence)
            return reject(
              new Error(
                `OneTrust not loaded after ${this.ONETRUST_LOAD_TIMEOUT}ms`
              )
            )
          }
        }, this.CHECK_INTERVAL)
      })
    } catch (error) {
      /*                                  */
      this.oneTrustPromiseInternal = undefined
      throw error
    }
  }

  private isOneTrustInitialized(oneTrust?: OneTrust): oneTrust is OneTrust {
    return !!oneTrust && !!document.getElementById('onetrust-consent-sdk')
  }
}
